var NavbarEvents = /** @class */ (function () {
    function NavbarEvents() {
    }
    NavbarEvents.prototype.productAddedToShoppingcartEvent = function (dom) {
        var navbar = dom.getElementById("webshopNavbar");
        var badge = navbar.querySelector('[id="shoppingcartProductBadge"]');
        var count = parseInt(badge.innerText) + 1;
        badge.innerText = count.toString();
    };
    NavbarEvents.prototype.displayShoppingcartPopup = function () {
    };
    return NavbarEvents;
}());
export default NavbarEvents;
